import React, { useEffect, useState } from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";
import { Checkbox, Input, Modal, notification, Radio, Space, Spin } from "antd";

import { ClickLoadingButton } from "components/buttons/ClickLoadingButton";
import { PhoneOutlined, SendOutlined } from "@ant-design/icons";
import { getRequest } from "services/EndPointApiService";
import { postRequest } from "services/EndPointApiService";

const generateLinkWA = ({ Nama, TglTransaksi, Status }) => {
  if (Status === "BELUM ADA ONGKIR") {
    return (
      "Halo kak " +
      Nama +
      ", pesanan kamu pada tanggal " +
      TglTransaksi.substring(0, 10) +
      " belum siap kirim dikarenakan belum ada ongkir *(Abaikan pesan jika sudah membayar)*. Silahkan lakukan pembayaran ongkir. Terima kasih."
    );
  }

  if (Status === "BELUM ADA ALAMAT") {
    return (
      "Halo kak " +
      Nama +
      ", pesanan kamu pada tanggal " +
      TglTransaksi.substring(0, 10) +
      " belum siap kirim dikarenakan belum ada alamat. Silahkan konfirmasi alamat. Terima kasih."
    );
  }

  if (Status === "SIAP KIRIM") {
    return (
      "Halo kak " +
      Nama +
      ", pesanan kamu pada tanggal " +
      TglTransaksi.substring(0, 10) +
      " sudah siap kirim. Silahkan hubungi kami jika ada keperluan keep atau ubah alamat. Terima kasih."
    );
  }

  if (Status === "BELUM BAYAR") {
    return (
      "Halo kak " +
      Nama +
      ", pesanan kamu pada tanggal " +
      TglTransaksi.substring(0, 10) +
      " belum siap kirim dikarenakan Belum Melakukan Pembayaran *(Abaikan pesan jika sudah membayar)*. Silahkan lakukan Pembayaran. Terima kasih."
    );
  }

  if (Status === "DI KEEP") {
    return (
      "Halo kak " +
      Nama +
      ", pesanan kamu pada tanggal " +
      TglTransaksi.substring(0, 10) +
      " Sudah di keep. Jika ingin dikirimkan segera silahkan beritahu kami. Terima kasih."
    );
  }

  return "";
};

const defaultDataStore = create(DataListStore);

const UpdatePesanan = () => {
  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  const [selectedPesanan, setSelectedPesanan] = useState({});

  const [modalOpen, setModalOpen] = useState(false);
  const [openMode, setOpenMode] = useState("KEEP");
  const [notesKeepan, setNotesKeepan] = useState("");
  const [ongkirFlag, setOngkirFlag] = useState(false);
  const [disableButton, setDisableButton] = useState({});

  const [modalMessageOpen, setModalMessageOpen] = useState(false);
  const [messageValue, setMessageValue] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);

  const [chatwootProfile, setChatwootProfile] = useState({});
  const [selection, setSelection] = useState({
    agent: 0,
    inbox: 0,
  });

  useEffect(() => {
    getRequest("Chatwoot/GetProfile").then((res) => {
      setChatwootProfile(res);
    });
  }, []);

  return (
    <>
      <Modal
        title={
          <p>
            +{selectedPesanan.Target} {selectedPesanan.Nama}
          </p>
        }
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        okText={openMode === "KEEP" ? "Keep Pesanan" : "Konfirmasi Pembayaran"}
        cancelButtonProps={{
          hidden: true,
        }}
        onOk={async () => {
          setDisableButton((prev) => ({
            ...prev,
            [openMode + "_" + selectedPesanan.No]: true,
          }));

          var data = {
            sesionId: selectedPesanan.SesionID,
            sequence: selectedPesanan.No,
            user: userObj.firstName,
            action: openMode,
            notes: notesKeepan,
          };

          if (openMode === "BAYAR" && ongkirFlag) {
            data.action = "BAYAR DAN ONGKIR";
          }

          const { affect } = await UpdateStatusPesanan(data);

          if (affect && affect > 0) {
            notification.success({
              message: "Update Status Pesanan",
              description: "Status pesanan berhasil di update",
            });
          } else {
            notification.error({
              message: "Update Status Pesanan",
              description: "Status pesanan gagal diupdate. Coba lagi nanti",
            });
          }

          setModalOpen(false);
        }}
      >
        {openMode === "KEEP" ? (
          <div>
            <label>Notes Keepan</label>
            <Input
              value={notesKeepan}
              onChange={(e) => setNotesKeepan(e.target.value)}
              placeholder="ex: Belum ongkir"
            />
          </div>
        ) : (
          <div>
            <Checkbox
              checked={ongkirFlag}
              onClick={(e) => setOngkirFlag(e.target.checked)}
            >
              Ceklist Pembayaran Beserta Ongkir
            </Checkbox>
          </div>
        )}
      </Modal>
      <Modal
        title={
          <p>
            +{selectedPesanan.Target} {selectedPesanan.Nama}
          </p>
        }
        open={modalMessageOpen}
        onCancel={() => setModalMessageOpen(false)}
        okText={
          <Space>
            Send message
            <SendOutlined />
          </Space>
        }
        cancelButtonProps={{
          hidden: true,
        }}
        okButtonProps={{
          loading: sendingMessage,
          disabled: sendingMessage || !selection?.agent || !selection?.inbox,
        }}
        onOk={async () => {
          setSendingMessage(true);
          if (selection.agent === 0 || selection.inbox === 0) {
            window.alert("Silahkan Pilih Pengirim dan Inbox Terlebih Dahulu.");
            setSendingMessage(false);
            return;
          }

          const data = {
            AgentId: selection.agent,
            InboxId: selection.inbox,
            NoHp: selectedPesanan.Target,
            Message: messageValue,
          };

          let result = await postRequest("Chatwoot/SendMessage", data);

          notification.success({
            message: "Send Message",
            description: result,
          });

          setTimeout(() => {
            setSendingMessage(false);
          }, 2000);
        }}
      >
        <strong>Kirim Pesan Melalui Channel Chatwoot</strong>
        <div style={{ display: "flex", marginBottom: "28px" }}>
          <Space wrap>
            <Space direction="vertical">
              <label>Pilih Agent Pengirim</label>
              <Radio.Group
                buttonStyle="solid"
                value={selection.agent}
                onChange={(e) => {
                  setSelection((prev) => ({
                    ...prev,
                    agent: e.target.value,
                  }));
                }}
              >
                <Space direction="vertical">
                  {chatwootProfile?.agents?.map(({ AgentId, AgentEmail }) => (
                    <Radio.Button key={AgentId} value={AgentId}>
                      {AgentEmail}
                    </Radio.Button>
                  ))}
                </Space>
              </Radio.Group>
            </Space>
            <Space direction="vertical">
              <label>Pilih Inbox Pengirim</label>
              <Radio.Group
                buttonStyle="solid"
                value={selection.inbox}
                onChange={(e) => {
                  setSelection((prev) => ({
                    ...prev,
                    inbox: e.target.value,
                  }));
                }}
              >
                <Space direction="vertical">
                  {chatwootProfile?.inboxes?.map(({ InboxId, InboxName }) => (
                    <Radio.Button key={InboxId} value={InboxId}>
                      {InboxName}
                    </Radio.Button>
                  ))}
                </Space>
              </Radio.Group>
            </Space>
          </Space>
        </div>
        <label>Isi Pesan</label>
        <Input.TextArea
          value={messageValue}
          rows={4}
          onChange={(e) => setMessageValue(e.target.value)}
        />
        {sendingMessage && (
          <div
            style={{
              margin: "10px 0",
            }}
          >
            <Space>
              <Spin spinning={sendingMessage} size="small" />
              Sending Message
            </Space>
          </div>
        )}
      </Modal>

      <ListViewV2
        hideEdit
        viewId={"updatepesanan"}
        store={defaultDataStore}
        customRowAction={(props) => (
          <Space style={{ display: "flex", justifyContent: "left" }}>
            <ClickLoadingButton
              type="primary"
              disabled={
                props.data.Status === "BELUM BAYAR" ||
                props.data.StatusKeepan ||
                disableButton["KEEP_" + props.data.No]
              }
              onClick={() => {
                setSelectedPesanan(props.data);
                setNotesKeepan("");
                setOpenMode("KEEP");
                setModalOpen(true);
              }}
            >
              Keep
            </ClickLoadingButton>
            <ClickLoadingButton
              danger
              disabled={
                props.data.Status !== "BELUM BAYAR" ||
                disableButton["BAYAR_" + props.data.No]
              }
              onClick={() => {
                setSelectedPesanan(props.data);
                setOpenMode("BAYAR");
                setOngkirFlag(false);
                setModalOpen(true);
              }}
            >
              Bayar
            </ClickLoadingButton>
            <ClickLoadingButton
              danger
              disabled={props.data.Status !== "BELUM ADA ONGKIR"}
              onClick={async () => {
                if (
                  window.confirm(
                    `Konfirmasi Pembayaran Ongkir dari ${props.data.Nama} ?`
                  )
                ) {
                  var data = {
                    sesionId: props.data.SesionID,
                    sequence: props.data.No,
                    user: userObj.firstName,
                    action: "ONGKIR",
                  };
                  const { affect } = await UpdateStatusPesanan(data);

                  if (affect && affect > 0) {
                    notification.success({
                      message: "Update Status Pesanan",
                      description: "Status pesanan berhasil di update",
                    });
                  } else {
                    notification.error({
                      message: "Update Status Pesanan",
                      description:
                        "Status pesanan gagal diupdate. Coba lagi nanti",
                    });
                  }
                }
              }}
            >
              Ongkir
            </ClickLoadingButton>
            <ClickLoadingButton
              type="link"
              onClick={() => {
                setMessageValue(generateLinkWA(props.data));
                setSelectedPesanan(props.data);
                setModalMessageOpen(true);
              }}
            >
              <Space>
                <PhoneOutlined /> Chat
              </Space>
            </ClickLoadingButton>
          </Space>
        )}
      />
    </>
  );
};

export default UpdatePesanan;
